import * as React from 'react';
import { ErrorRow } from './ErrorRow';
import './style/index.scss';
export class TeamEmployeeErrorTable extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.handleEditRowSelect = this.handleEditRowSelect.bind(this);
        this.renderErrorRow = this.renderErrorRow.bind(this);
        this.state = {
            errorCount: this.countTotalErrors(this.props.employeeData),
            employeeCount: (_a = this.props.employeeData.length, (_a !== null && _a !== void 0 ? _a : 0))
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.employeeData !== this.props.employeeData) {
            const errorCount = this.countTotalErrors(this.props.employeeData);
            const employeeCount = this.props.employeeData.length;
            this.setState({ errorCount, employeeCount });
        }
    }
    render() {
        if (this.props.employeeData && this.props.employeeData.length) {
            return (React.createElement("div", { className: "employee-error-table" },
                React.createElement("div", { className: "employee-error-table__header" },
                    React.createElement("div", { className: "employee-error-table__employee-count" },
                        "Employees (",
                        this.state.employeeCount,
                        ")"),
                    React.createElement("div", { className: "employee-error-table__error-count" },
                        "Errors (",
                        this.state.errorCount,
                        ")")),
                React.createElement("ul", { className: "employee-error-table__contents" }, this.props.employeeData.map(this.renderErrorRow))));
        }
        return null;
    }
    countTotalErrors(employeeData) {
        return employeeData.reduce(((total, errorArray) => total + Object.keys(errorArray.errorDetails).length), 0);
    }
    handleEditRowSelect(index) {
        this.props.onEditClickCallBack(index);
    }
    renderErrorRow(employeeErrorData, index) {
        const onEditHandler = () => {
            this.handleEditRowSelect(index);
        };
        return (React.createElement(ErrorRow, { employee: employeeErrorData, key: index, onEditClickCallBack: onEditHandler, ignoreUserCallBack: this.props.ignoreUserCallBack, inviteUserCallBack: this.props.inviteUserCallBack }));
    }
}
export default { TeamEmployeeErrorTable };
